export default {
  functional: true,
  render (h, ctx) {
    return ctx.children
  }
}
